/**
 * A v4-shaped id. `crypto.randomUUID` where the runtime has it (browsers,
 * Node); React Native's Hermes has no `crypto` global, and the demo and the
 * app's outbox must work there too — these ids only need to be unique for
 * one person on one device, not unguessable.
 */
export function randomId(): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (c?.randomUUID) return c.randomUUID();
  const hex = (n: number) => Array.from({ length: n }, () => Math.floor(Math.random() * 16).toString(16)).join('');
  return `${hex(8)}-${hex(4)}-4${hex(3)}-${'89ab'[Math.floor(Math.random() * 4)]}${hex(3)}-${hex(12)}`;
}
